import { CardContent, FormControl, MenuItem, Select } from '@mui/material'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { baseCovidurl } from '../../../constants/const'
import '../covid/covid.css'
import InfoBox from './covid_components/InfoBox'
import Table from './covid_components/Table'
import Chart from './covid_components/Chart'
import HistoricalDataChart from './covid_components/HistoricalDataChart'
const Dashboard = () => {

    const [covidData, setCovidData] = useState({
        loading: false,
        data: [],
        countries: []

    })

    const [country, setCountry] = useState('worldwide');
    const [countryInfo, setCountryInfo] = useState({})
    

    //fetch all data
    const fetchdata = async (url) => {
        setCovidData((old) => ({ ...old, loading: true }))
        const res = (await axios.get(url)).data;
        console.log(res)
        const countries = res?.map((currdata) => (
            {
                name: currdata.country,
                value: currdata.countryInfo.iso2
            }
        )

        )
        setCovidData((old) => ({ ...old, data: res, loading: false, countries: countries }))
    }

    //fetch worldwide data
    const fetchWorldwideData = async (url) => {
        const res = (await axios.get(url)).data
        setCountryInfo(res)

    }


    useEffect(() => {
        fetchdata(`${baseCovidurl}/countries`)
    }, [])



    useEffect(() => {
        fetchWorldwideData(`${baseCovidurl}/all`);
    }, [])


    const onCoutryChange = async (country) => {
        setCountry(country)
        if (country === "worldwide") {
            const res = (await axios.get(`${baseCovidurl}/all`)).data;
            setCountryInfo(res)
        }
        else {
            const res = (await axios.get(`${baseCovidurl}/countries/${country}`)).data;
            setCountryInfo(res)
        }

    }




    return (
        <>

            <div className="app">
                <div className="app__left">
                    <div className="app__header">
                        <h1>COVID-19 tracker</h1>
                        <FormControl className="app__dropdown" >
                            <Select variant="outlined" value={country && country} onChange={(e) => onCoutryChange(e.target.value)} >
                                <MenuItem value="worldwide">Worldwide</MenuItem>
                                {covidData.countries?.map(country => <MenuItem value={country.value}>{country.name}</MenuItem>)}
                            </Select>
                        </FormControl>
                    </div>
                    <div className="app__stats">
                        <InfoBox title="CoronaVirus Cases" total={countryInfo?.cases} cases={countryInfo?.todayCases} active={true} />
                        <InfoBox title="Recovered" total={countryInfo?.recovered} cases={countryInfo?.todayRecovered} isGreen={true} />
                        <InfoBox title="Deaths" total={countryInfo?.deaths} cases={countryInfo?.todayDeaths} />                      
                    </div>
                    <Chart data={covidData.data}/>
                </div>
                <div className="app__right">
                    <CardContent>
                        <h3>Live Cases by Country</h3>
                        <Table countries={covidData.data}></Table>
                        
                      
                    </CardContent>
                </div>
               

            </div>


        </>
    )
}

export default Dashboard